import { connect } from 'react-redux';
import AdminUsers from './users';

function mapStateToProps(state) {
  return {
    myUserId: state.profile.id
  };
}

export default connect(mapStateToProps)(AdminUsers);

